import React, { useContext, useEffect, useState } from "react";

import Loading from "./Loading";
import Message from "./Message";
import { MESSAGE_ALERT_TYPES } from "../utils/messages";
import { MessagesContext } from "../contexts/messages";
import { useDispatch, useSelector } from "react-redux";
import { setAllUnreadMessages } from "actions/notifications";

const Messages = () => {
    const { messages: allMessages, loading, markMessagesAsRead } = useContext(MessagesContext);

    const dispatch = useDispatch();

    const { arrUnreadMessages } = useSelector((state) => state.session);
    const [messages, setMessages] = useState(null);
    const [unreadMessages, setUnreadMessages] = useState(null);
    const [prepareRead, setPrepareRead] = useState({ confirm: false, messages: [] });
    const [indexShowing, setIndexShowing] = useState(0);

    const message = messages?.length > 0 ? messages?.[indexShowing] : null;

    const readMessage = (confirm) => {
        if (message && prepareRead?.messages?.filter((m) => m.id === message.id).length === 0) {
            setPrepareRead({
                ...prepareRead,
                ...(confirm ? { confirm: true } : null),
                messages: [
                    ...(prepareRead ? prepareRead.messages : null),
                    {
                        id: message.id,
                        projectRef: message.projectRef,
                    },
                ],
            });
        }
    };

    useEffect(() => {
        setMessages(allMessages?.filter((m) => MESSAGE_ALERT_TYPES.includes(m?.priority) && !m?.isRead));
        setUnreadMessages(allMessages?.filter((m) => !m?.isRead));
    }, [allMessages]);

    useEffect(() => {
        if (unreadMessages?.length > 0) {
            const updatedMessages = processUnreadMessages(arrUnreadMessages || [], unreadMessages);
            dispatch(setAllUnreadMessages({ arrUnreadMessages: updatedMessages }));
        }
    }, [unreadMessages]);

    useEffect(() => {
        if (prepareRead?.confirm) {
            const msgProjects = prepareRead?.messages?.reduce((a, b) => {
                if (!a[b.projectRef]) {
                    a[b.projectRef] = [];
                }
                a[b.projectRef].push(b.id);
                return a;
            }, {});
            Object.entries(msgProjects).forEach(([projectRef, messageIDs]) => {
                if (messageIDs && messageIDs.length > 0) {
                    markMessagesAsRead({
                        projectRef,
                        messageIDs,
                    });
                }
            });
            setPrepareRead({ confirm: false, messages: [] });
        }
    }, [prepareRead?.confirm]);

    return (
        <>
            {loading ? <Loading /> : null}
            {message ? (
                <Message
                    message={message}
                    onClose={() => {
                        setMessages(null);
                        setIndexShowing(0);
                        readMessage(true);
                    }}
                    messages={messages}
                    pagination={
                        messages.length > 1
                            ? {
                                  current: indexShowing + 1,
                                  total: messages.length,
                                  prev: () => {
                                      setIndexShowing(indexShowing - 1);
                                  },
                                  next: () => {
                                      readMessage(false);
                                      setIndexShowing(indexShowing + 1);
                                  },
                              }
                            : null
                    }
                />
            ) : null}
        </>
    );
};

export default Messages;

const processUnreadMessages = (currentMessages, newMessages) => {
    const getMappedNewMessages = (newMessages) => {
        return newMessages.map((m) => ({
            id: m.id,
            tracked: false,
            priority: m.priority,
        }));
    };

    const updateTrackedMessages = (messages) => {
        return messages.map((m) => {
            return { ...m, tracked: true };
        });
    };

    const existingMessageIds = new Set(currentMessages.map((m) => m.id));
    const newFilteredMessages = newMessages.filter((m) => !existingMessageIds.has(m.id));
    const mappedNewMessages = getMappedNewMessages(newFilteredMessages);
    let combinedMessages = currentMessages.concat(mappedNewMessages);
    return updateTrackedMessages(combinedMessages);
};
